import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-star-rating-aggregate-item',
  templateUrl: './star-rating-aggregate-item.component.html',
  styleUrls: ['./star-rating-aggregate-item.component.scss'],
  standalone: false
})
export class StarRatingAggregateItemComponent implements OnInit {
  @Input() answers: string[];
  rating: number;
  constructor() {}

  ngOnInit(): void {
    this.rating = _.mean(this.answers.filter((x) => x != '0').map((x) => +x));
    if (this.rating)
      this.rating = Number.isInteger(this.rating) ? this.rating : Number(this.rating.toFixed(2));
  }

  getExactRating() {
    if (this.rating == 1) return this.rating + ' star';
    return this.rating + ' stars';
  }
}
